<template>
    <div>
        <table class="w3-table w3-bordered flow-table patients-table">
            <thead class="">
            <th>{{ $t("date") }}</th>
            <th>ID</th>
            <th>{{ $t("name") }}</th>
            <th>{{ $t("tag") }}</th>
            <th>{{ $t("phone") }}</th>
            </thead>
            <tbody v-show="badges.length === 0">
            <tr>
                <td colspan="8" class="w3-center flow-blue-color">
                    <b class="font-size-1pt25em">{{$t("noLostBadges")}}</b>
                </td>
            </tr>
            </tbody>
            <tbody v-show="badges.length !== 0">
            <tr v-for="badge in badges"
                v-bind:id="badge.id"
                v-if="badge" :key="badge.id">
                <td>
                    <span v-if="badge.lastSeenAt">{{ toDate(badge.lastSeenAt) }}</span>
                </td>

                <td>
                    {{ badge.patientHISId}}
                </td>

                <td>
                    {{ badge.patientName }}
                </td>

                <td>
                    {{ badge.badge }}
                </td>

                <td>
                    <span v-if="badge.contact">
                        {{getContactHome(badge.contact)}}
                        <br v-if="getContactHome(badge.contact) && getContactBusiness(badge.contact)">
                        {{getContactBusiness(badge.contact)}}
                    </span>
                </td>
            </tr>
            </tbody>
        </table>
    </div>
</template>

<script>
    export default {
        name: "LostBadges",
        props: ['badges'],
        methods: {
            toDate(lastSeen) {
                const event = new Date(lastSeen);
                var day = event.getDate();
                var month = event.getMonth() + 1;
                var year = event.getFullYear();
                var badgeDate = day + "-" + month + "-" + year;
                return badgeDate;
            },
            getContactHome(contact) {
                var home = JSON.parse(contact);
                return home.home_phone;
            },
            getContactBusiness(contact) {
                var bus = JSON.parse(contact);
                return bus.business_phone;
            }
        }
    }
</script>

<style>
</style>